import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import AdminSideBar from './../../Containers/AdminSideBar';
import { ApplicationContainer } from './../../Containers/ApplicationContainer';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';


function Applications() {
    const { t } = useTranslation();
    return ( 
        <>
            <div className='ContentsWrapper ContentsWrapper2'>
                <Helmet>
                        <meta charSet="utf-8" />
                        <title>
                            {t("st:head.menu")} | {t("head.appTitle")}
                        </title>
                </Helmet>
                <AdminSideBar />
                <ApplicationContainer />
            </div>
        </>
     );
}

export default observer(Applications);